import React from "react";
import styled from "styled-components";

import { colors, device, fonts } from "../App/StyleVariables";
import { BlankLink } from "../Shared";

const MainHeadline = styled.h2`
  font-family: ${fonts.brandon};
  font-size: 1.75rem;
  letter-spacing: 0.0625rem;
  line-height: 2.5rem;
  margin: 0 auto;
  text-align: center;

  @media ${device.sm} {
    font-size: 2.25rem;
    line-height: 3rem;
    max-width: 20rem;
  }

  @media ${device.md} {
    font-size: 2.625rem;
    line-height: 3.25rem;
  }
`;

const MainSubHead = styled.p`
  line-height: 1.5rem;
  margin: 1rem auto 1.875rem;
  text-align: center;

  @media ${device.sm} {
    line-height: 1.75rem;
    margin-bottom: 2rem;
    max-width: 52%;
  }

  @media ${device.md} {
    margin-bottom: 2.375rem;
    margin-top: 1.125rem;
  }

  a {
    color: ${colors.white};
  }
`;

const MainHeading = () => (
  <React.Fragment>
    <MainHeadline children="Worth the wait? We think so." />
    <MainSubHead>
      We’re currently available in the{" "}
      <BlankLink href="https://www.harrys.com/en/gb?sticky=true">UK</BlankLink>,{" "}
      <BlankLink href="https://www.harrys.com/de/de?sticky=true">Germany</BlankLink>,{" "}
      <BlankLink href="https://www.harrys.com/fr/fr?sticky=true">France</BlankLink>,{" "}
      <BlankLink href="https://www.harrys.com/nl/be?sticky=true">Belgium</BlankLink>,{" the "}
      <BlankLink href="https://www.harrys.com/nl/nl?sticky=true">Netherlands</BlankLink>,{" "}
      <BlankLink href="https://www.harrys.com/en/us?sticky=true">US</BlankLink>
      , and {" "}
      <BlankLink href="https://www.harrys.com/en/ca?sticky=true">Canada</BlankLink>.
    </MainSubHead>
    <MainSubHead>
      If you’d like to shave with Harry’s, submit your email and we’ll let you know when we’re available in your country.
    </MainSubHead>
  </React.Fragment>
);

export default MainHeading;
